function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { useFocus } from './useFocus';
import { Icon } from '../../index';
import { FieldInstructions } from '../FieldInstructions/FieldInstructions';
export var TextField = function TextField(props) {
  var _useFocus = useFocus(props),
      onChange = _useFocus.onChange,
      onBlur = _useFocus.onBlur,
      onFocus = _useFocus.onFocus,
      onKeyDown = _useFocus.onKeyDown,
      focus = _useFocus.focus,
      setFocus = _useFocus.setFocus,
      inputRef = _useFocus.inputRef;

  var inputLabelId = props.label && props.id ? "".concat(props.id, "-label") : undefined;
  var statusIcon = props.success ? /*#__PURE__*/React.createElement(Icon, {
    icon: "check-mark-circle"
  }) : props.error ? /*#__PURE__*/React.createElement(Icon, {
    icon: "alert"
  }) : null;
  var inputHasValue = props.value && props.value.length || inputRef.current && inputRef.current.value.length;
  /**
   * To support the compact TextField we need to position the label within the input,
   * and move to the borde when input is active.
   * To position it correctly we need to find the width of the items in front of the input
   * an apply the appropriate offset.
   */

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      compactLabelLeftOffset = _useState2[0],
      setCompactLabelLeftOffset = _useState2[1];

  var leftContentRef = useRef(null);
  useEffect(function () {
    return setCompactLabelLeftOffset(leftContentRef.current ? leftContentRef.current.clientWidth : undefined);
  }, [leftContentRef.current]);
  var labelStyle = props.size === 'compact' && !(focus || inputHasValue) && compactLabelLeftOffset ? {
    left: "calc(".concat(compactLabelLeftOffset, "px + 0.75rem)")
  } : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('telia-textfield', {
      'telia-textfield--focus': !!focus,
      'telia-textfield--success': !!props.success,
      'telia-textfield--error': !!props.error,
      'telia-textfield--disabled': !!props.disabled,
      'telia-textfield--compact': props.size === 'compact',
      'telia-textfield--withValue': inputHasValue,
      'telia-textfield--white': props.kind === 'white',
      'telia-textfield--grey': props.kind === 'grey',
      'telia-textfield--prepended': !!props.leftContent,
      'telia-textfield--appended': !!props.rightContent || props.success || props.error
    }, props.className),
    onClick: function onClick() {
      if (!props.disabled) {
        setFocus(true);
      }
    }
  }, /*#__PURE__*/React.createElement("div", null, props.label ? /*#__PURE__*/React.createElement("label", {
    style: labelStyle,
    className: cn('telia-textfield__label'),
    id: inputLabelId
  }, props.label) : null, props.fieldInstructionsProps && /*#__PURE__*/React.createElement(FieldInstructions, props.fieldInstructionsProps), /*#__PURE__*/React.createElement("div", {
    className: "telia-textfield__content"
  }, props.leftContent ? /*#__PURE__*/React.createElement("div", {
    ref: leftContentRef,
    className: "telia-textfield__leftContent",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props.leftContent) : null, /*#__PURE__*/React.createElement("input", {
    className: "telia-textfield__input",
    id: props.id,
    name: props.name,
    ref: inputRef,
    type: props.type || 'text',
    placeholder: props.placeholder,
    disabled: props.disabled,
    value: props.value,
    "aria-label": props['aria-label'],
    "aria-labelledby": inputLabelId,
    "aria-activedescendant": props['aria-activedescendant'],
    "aria-autocomplete": props['aria-autocomplete'],
    "aria-controls": props['aria-controls'],
    autoComplete: props.autoComplete,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    onKeyUp: props.onKeyUp,
    maxLength: props.maxlength
  }), statusIcon ? /*#__PURE__*/React.createElement("span", {
    className: "telia-textfield__status"
  }, statusIcon) : null, props.rightContent ? /*#__PURE__*/React.createElement("div", {
    className: "telia-textfield__rightContent",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props.rightContent) : null)), /*#__PURE__*/React.createElement("small", {
    className: cn('telia-textfield__helptext')
  }, props.helpText));
};